<template>
  <div class="modal">
    <div v-on:click="close" class="modal-click-outside-area">
    </div>
    <div class="modal-content">
      <div class="modal-header">
        <p class="small-header">Translation</p>
      </div>
      <!-- {{isVerbInForm}} -->
      <!-- {{getLookupWordsV2}} -->
      <span v-if="isVerbInForm && getLookupWordsV2.queryText">
        <!-- <h1>Is verb in tens</h1> -->
        <div class="modal-body">
          <div class="words-wrap">
            <p class="word-description">Spanish:</p>
            <p class="word-translation">{{getLookupWordsV2.queryText}}</p>
          </div>
          <div class="words-wrap">
            <p class="word-description">English:</p>
            <span class="word-translation-def-wrap">
              <p class="word-translation">
                {{englishWordFallback}}
              </p>
            </span>
          </div>
          <p class="word-explained">The word <span class="word-in-bold">{{getLookupWordsV2.queryText}}</span> is the 
          {{getLookupWordsV2.verbInfo.tense}} form of <span class="word-in-bold">{{getLookupWordsV2.verbInfo.word}}</span>
          in {{getLookupWordsV2.verbInfo.person}}.
          </p>
          <p class="word-explained-defs">
            ({{getLookupWordsV2.verbInfo.word}}: {{getLookupWordsV2.def1}}<span v-if="getLookupWordsV2.def2" class="word-translation-def-space">,</span> 
            {{getLookupWordsV2.def2}})
          </p>
        </div>
      </span>

      <span v-else-if="!isVerbInForm && getLookupWordsV2.queryText">
        <!-- <h1>Is not verb in tens</h1> -->
      <div class="modal-body">
        <div class="words-wrap">
          <p class="word-description">Spanish:</p>
          <p class="word-translation">{{getLookupWordsV2.queryText}}</p>
        </div>
        <div class="words-wrap">
          <p class="word-description">English:</p>
          <span class="word-translation-def-wrap">
            <!-- {{getLookupWordsV2}} -->
            <dot-puls-loader v-if="getLookupWordsV2.def1 == null && getLookupWordsV2.def2 == null"/>
            <p class="word-translation">{{getLookupWordsV2.def1}}</p>
            <span v-if="getLookupWordsV2.def2" class="word-translation-def-space">,</span>
            <p class="word-translation">{{getLookupWordsV2.def2}}</p>
          </span>
        </div>
      </div>
      </span>
      <span v-else>
        <p>Sorry, can't find the word!</p>
      </span>
      <div class="modal-bottom">
        <button class="close-btn" v-on:click="close">Ok</button>
      </div>
    </div>
  </div>
</template>

<script>
// import ClickOutside from 'vue-click-outside'
import dotPulsLoader from '@/components/dotPulsLoader.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'wordLookUpModalV2',
  components: {
    dotPulsLoader
  },
  methods: {
    close: function(){
      this.$store.commit('closeLookupModal')
    },
    open: function(){
      this.$store.commit('openLookupModal')
    },
    capFirstLet: function(string) {
      if(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      } else {
        return null
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLookupWordsV2'
    ]),
    englishWordFallback() {
      return (this.getLookupWordsV2.verbInfo.variationTranslation ? this.getLookupWordsV2.verbInfo.variationTranslation : this.getLookupWordsV2.def1);
    },
    defsCapLet() {
      let upperWords = {}
      upperWords.word = this.capFirstLet(this.getLookupWordsV2.verbInfo.word)
      upperWords.def1 = this.capFirstLet(this.getLookupWordsV2.def1)
      upperWords.def2 = this.capFirstLet(this.getLookupWordsV2.def2)
      return upperWords
    },
    // getLookupWords() {
    //   return this.$store.getters.getLookupWords
    // },
    isVerbInForm() {
      if(this.getLookupWordsV2.verbInfo) {
        return true
      } else {
        return false
      }
    },
    // getLookupWordsV2() {
    //   return this.getLookupWordsV2
    // }
  },
  mounted () {
    // prevent click outside event with popupItem.
    // this.popupItem = this.$el
  }
  // directives: {
  //   ClickOutside
  // }
}
</script>

<style scoped>
  .modal-click-outside-area {
    cursor: pointer;
    position: absolute;
    display: block;
    content: " ";
    height: 100vh;
    width: 100%;
    top: 0;
  }
  .small-header {
    font-weight: bold;
    font-size: 20px;
    margin-top: 0px;
    border-bottom: 1px solid whitesmoke;
    padding: 0 0 17px 0;
  }
  .modal-body {
    margin-top: 27px; 
  }
  .modal-bottom {
    margin-top: 16px;
    padding-top: 20px;
    border-top: 1px solid whitesmoke;
  }
  .words-wrap{
    font-size: 20px;
  }
  .word-translation, .word-description {
    margin: 0 0 15px 0;
  }
  .word-translation {
    font-weight: bold;
    margin-left:10px;
  }
  .word-translation-def-wrap {
    display: flex;
    flex-wrap: wrap;
    font-weight: bold;
  }
  .words-wrap {
    display: flex;
  }
  .word-in-bold {
    font-weight: bold;
  }
  .word-explained, .word-explained-defs {
    text-align: left;
  }
  .modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 99; /* Sit on top */
    padding-top: 120px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }
  .modal-content {
    position: relative;
    border-radius: 4px;
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    width: 80%;
    max-width: 310px;
  }
  .close-btn {
    padding: 5px 0;
    font-size: 20px;
    border: none;
    cursor: pointer;
    font-weight: bold;
    /* font-size: 1.4rem; */
    color: white;
    border-radius: 4px;
    /* height: 40px;
    line-height: 40px; */
    background-color: #00BAE0;
    margin: 0 auto;
    width: 80px;
  }

  @media screen and (max-width: 768px) {
   .modal {
    cursor: pointer; 
  }
}
</style>